export const isEventDisabled = (isOverdue: boolean, eventEnd: string) => {
  return !isOverdue && new Date(eventEnd).getTime() < new Date().getTime();
};
